// extracted by mini-css-extract-plugin
module.exports = {"trend-arrow":"deFE2","up":"_09MRK","train":"rLPGN","down":"YuPby","up-icon":"-8DMQ","down-icon":"tD5Pg"};